export enum ActionTypes {
  GET_PORTFOLIO_ITEMS = 'GET_PORTFOLIO_ITEMS',
  GET_PORTFOLIO_ITEMS_SUCCESS = 'GET_PORTFOLIO_ITEMS_SUCCESS',
  GET_PORTFOLIO_ITEMS_FAILED = 'GET_PORTFOLIO_ITEMS_FAILED'
}
